import Bowser from 'bowser';
/**
 * Handles browser detection.
 */
export default class BrowserDetection {
    /**
     * Browser support detection.
     *
     * @param browserList Optional browser list in Bowser Format.
     * @returns Boolean value.
     */
    static hasSupport(browserList) {
        const browser = Bowser.getParser(window.navigator.userAgent);
        return browser.satisfies(browserList);
    }
    /**
     * Gets current browser.
     *
     * @returns Current browser information.
     */
    static getBrowser() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        return browser.getBrowser();
    }
    /**
     * Gets current platform.
     *
     * @returns Current platform name.
     */
    static getPlatform() {
        const browser = Bowser.parse(window.navigator.userAgent);
        return browser.platform.type;
    }
}
//# sourceMappingURL=BrowserDetection.js.map